import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { checkSession, setInitialAuthState } from "../actions/authActions";
import { connect } from "react-redux";

export const AuthProvider = ({ children, checkSession, initialState, setInitialAuthState }) => {
  useEffect(() => {
    setInitialAuthState(initialState);
  }, [initialState, setInitialAuthState]);

  // this can be used to check the session periodically.
  // however, as of now if a session expires while the user is in a protected screen
  // then a login is immediately triggered, which is not a good user experience.
  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     checkSession();
  //   }, 1000 * 60 * 5); // every 5 minutes
  //   return () => clearInterval(intervalId);
  // }, []);
  return children;
};

AuthProvider.propTypes = {
  children: PropTypes.node,
  checkSession: PropTypes.func,
  initialState: PropTypes.object
};

export default connect(null, { checkSession, setInitialAuthState })(AuthProvider);
